module.exports = __webpack_public_path__ + "static/media/GH_Logo-latest.4d1398fc.png";